import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "@mui/material/styles";
import { DatePicker, PickersDay } from "@mui/x-date-pickers-pro";
import withStaticMode from "../hocs/withStaticMode";
import { default as BryxColors, default as theme } from "../types/theme";
import BryxInput from "./BryxInput";
import { BryxBox } from "./index";
const BryxPickersDay = styled(PickersDay)(({ theme }) => ({
// see theme override
}));
const BryxDatepicker = styled(({ error, errorText, className, InputProps, ...rest }) => {
    const palette = "light";
    return (_jsx(BryxBox, { ...rest, className: className, children: _jsx(DatePicker, { reduceAnimations: true, disableHighlightToday: true, ...rest, views: ["day"], OpenPickerButtonProps: {
                sx: {
                    background: "none !important",
                    color: theme.brandDark2(palette),
                    left: "4px",
                    borderRadius: "4px",
                    "&:hover": {
                        backgroundColor: theme.arrowBackground(palette),
                    },
                },
            }, PopperProps: {
                sx: { padding: "22px", "& .MuiPickersPopper-root": { zIndex: 9e2 } },
            }, mask: "__/__/____", inputFormat: "MM/DD/YYYY", InputProps: InputProps, renderInput: ({ inputProps, value, ...rest }) => (_jsx(BryxInput, { ...rest, value: value ?? "", autoComplete: "off", error: error, errorText: errorText, inputProps: {
                    ...inputProps,
                    ...InputProps,
                    placeholder: "MM/DD/YYYY",
                } })), renderDay: (date, selectedDays, pickersDayProps) => (_jsx(BryxPickersDay, { ...pickersDayProps, disableRipple: true })) }) }));
})(({ theme }) => {
    const palette = theme.palette.mode;
    const hoverColor = BryxColors.brand1(palette);
    const activeColor = palette == "light" ? BryxColors.brandDark2(palette) : BryxColors.brand4(palette);
    const inactiveColor = BryxColors.notify(palette, "inactive");
    return {
        "& .MuiTypography-root": {
            color: activeColor,
        },
        "&:hover": {
            "& .MuiTypography-root": {
                color: hoverColor,
            },
            "& .MuiInputBase-root *": {
                color: hoverColor,
                fill: hoverColor,
                "&::placeholder": {
                    opacity: 1,
                },
                "& button *": {
                    fill: hoverColor,
                },
            },
            "& .MuiInputBase-root": {
                borderWidth: "1px",
                borderColor: hoverColor,
            },
        },
        "body:not(:has(.MuiPopperUnstyled-root)) &:hover:not(:has(.Mui-focused)) ~ .MuiFormLabel-root": {
            color: hoverColor,
        },
        "body:has(.MuiPopperUnstyled-root) & ~ .MuiFormLabel-root": {
            color: activeColor,
        },
        "&.Mui-focused ~ .MuiFormLabel-root": {
            color: activeColor,
        },
        "& .MuiInputBase-root": {
            borderWidth: "1px",
            right: "1px",
            "&::placeholder": {
                color: inactiveColor,
                opacity: 1,
            },
            "&.Mui-focused ::placeholder": {
                color: activeColor,
                opacity: 1,
            },
        },
        "& .MuiInputBase-root:not(.Mui-focused)": {
            "& *": {
                fill: inactiveColor,
                borderRadius: "4px",
            },
            "&:has(input:not(:placeholder-shown)) *": {
                fill: activeColor,
                borderRadius: "4px",
            },
            "&:hover svg": {
                fill: hoverColor,
            },
            borderWidth: "1px",
        },
        // Focus (clicked and/or open)
        "body:has(.MuiPopperUnstyled-root) & .MuiInputBase-root, body:has(.MuiPopperUnstyled-root) & .MuiInputBase-root": {
            "& *, &:hover, &:hover *": {
                color: `activeColor !important`,
                fill: `activeColor !important`,
                borderColor: `activeColor !important`,
            },
            "& ~ .MuiFormLabel-root": {
                color: `activeColor !important`,
            },
        },
        "& .MuiInputBase-root.Mui-focused, & .MuiInputBase-root.Mui-focused": {
            borderColor: `${activeColor} !important`,
            borderWidth: "1px",
            "& *": {
                borderRadius: "4px",
                "& button:hover *": {
                    fill: hoverColor,
                },
            },
        },
        // Hover, not focused
        "& .MuiInputBase-root:not(.Mui-focused):hover, & .MuiInputBase-root:not(.Mui-focused):hover *": {
            color: hoverColor,
            fill: hoverColor,
            "&::placeholder": {
                opacity: 1,
            },
            "& ~ .MuiFormLabel-root": {
                color: hoverColor,
            },
        },
        // Hover and focused
        "& .Mui-focused:hover *": {
            color: activeColor,
            fill: activeColor,
            borderColor: `${activeColor} !important`,
            borderWidth: "1px",
        },
        // change input color if it has content
        "& .MuiInputBase-root:has(input:not(:placeholder-shown))": {
            "& *": {
                color: activeColor,
            },
            "&:not(.Mui-focused):hover *, & button:hover *": {
                fill: hoverColor,
            },
        },
    };
});
export default withStaticMode(BryxDatepicker);
